import { render, staticRenderFns } from "./addAplic.vue?vue&type=template&id=3cf164b1&scoped=true&"
import script from "./addAplic.vue?vue&type=script&lang=js&"
export * from "./addAplic.vue?vue&type=script&lang=js&"
import style0 from "./addAplic.vue?vue&type=style&index=0&id=3cf164b1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cf164b1",
  null
  
)

export default component.exports